import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { ConfigEntryType, ConfigFieldEntryType, ConfigEntryFieldType } from 'config/config';

export const DEFAULT_APPLICATION_BASED_POST_FIELDS: ConfigEntryType[] = [
  {
    entryCode: 'title',
    entryDescription: 'Title',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'Title',
      placeHolder: 'Add a title',
      isRequired: true,
    },
  },
  {
    entryCode: 'description',
    entryDescription: 'Description',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.EDITOR,
      label: 'Description',
      placeHolder: 'Add a description',
    },
  },
  {
    entryCode: 'attachments',
    entryDescription: 'Attachments',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.ATTACHMENTS,
      label: 'Attachments',
      placeHolder: 'Drop files here to attach',
    },
  },
  {
    entryCode: 'projectId',
    entryDescription: 'Project',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      label: 'Project',
      placeHolder: 'Select Project',
    },
    targetMapperType: 'API',
  },
  {
    entryCode: 'projectPhases',
    entryDescription: 'Phases',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      configRefName: 'PROJECT_PHASES',
      label: 'Phases',
      placeHolder: 'Select Phases',
    },
    targetMapperType: 'CONFIG',
  },
  {
    entryCode: 'partnerIds',
    entryDescription: 'Partners',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      label: 'Partners',
      placeHolder: 'Select Partners',
    },
    targetMapperType: 'API',
  },
  {
    entryCode: 'playListArticleIds',
    entryDescription: 'Playlists',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      label: 'Collections',
      placeHolder: 'Select Collections',
    },
    targetMapperType: 'API',
  },
  {
    entryCode: 'topics',
    entryDescription: 'Topics',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      configRefName: 'TOPICS',
      label: 'Topics',
      placeHolder: 'Select Topics',
    },
    targetMapperType: 'CONFIG',
  },
  {
    entryCode: 'divisions',
    entryDescription: 'Divisions',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      label: 'Divisions',
      placeHolder: 'Select Divisions',
    },
    targetMapperType: 'API',
  },
  {
    entryCode: 'specSections',
    entryDescription: 'Spec Sections',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      label: 'Spec Sections',
      placeHolder: 'Select Spec Sections',
    },
    targetMapperType: 'API',
  },
];

export const DEFAULT_APPLICATION_BASED_QUESTION_FIELDS: ConfigEntryType[] = [
  {
    entryCode: 'title',
    entryDescription: 'Title',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'Title',
      placeHolder: 'Add a title',
      isRequired: true,
    },
  },
  {
    entryCode: 'description',
    entryDescription: 'Enter your question',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.EDITOR,
      label: 'Enter your question',
      placeHolder: 'Enter your question',
      isRequired: true,
    },
  },
  {
    entryCode: 'attachments',
    entryDescription: 'Attachments',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.ATTACHMENTS,
      label: 'Attachments',
      placeHolder: 'Drop files here to attach',
    },
  },
];

export const DEFAULT_APPLICATION_BASED_SUGGESTION_FIELDS: ConfigEntryType[] = [
  {
    entryCode: 'title',
    entryDescription: 'Title',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXT,
      label: 'Title',
      placeHolder: 'Add a title',
      isRequired: true,
    },
  },
  {
    entryCode: 'targetGroups',
    entryDescription: 'Target Groups',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      label: 'Target Groups',
      placeHolder: 'Select Target Groups',
      configRefName: 'DEPARTMENTS',
      isRequired: true,
    },
  },
  {
    entryCode: 'region',
    entryDescription: 'Target Regions',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.MULTI_SELECT,
      label: 'Target Regions',
      placeHolder: 'Select Target Groups',
      configRefName: 'REGIONS',
      isRequired: false,
    },
  },
  {
    entryCode: 'taskOwner',
    entryDescription: 'Assigned To',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    targetMapperJavaScriptFunction: 'UserListComponent',
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      label: 'Assigned To',
      placeHolder: 'Select Assigned To',
      isRequired: false,
    },
  },
  {
    entryCode: 'description',
    entryDescription: 'Provide you suggestion',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.EDITOR,
      label: 'Provide you suggestion',
      placeHolder: 'Provide you suggestion',
      isRequired: true,
    },
  },
  {
    entryCode: 'attachments',
    entryDescription: 'Attachments',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.ATTACHMENTS,
      label: 'Attachments',
      placeHolder: 'Drop files here to attach',
    },
  },
];

export const MANDATORY_APPLICATION_BASED_EDIT_SUGGESTION_FIELDS: ConfigEntryType[] = [
  {
    entryCode: 'taskStatus',
    entryDescription: 'Status',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.SELECT,
      configRefName: 'SUGGESTION_STATUSES',
      label: 'Status',
      placeHolder: 'Select status',
    },
  },
  {
    entryCode: 'comment',
    entryDescription: 'Comment',
    entryType: ConfigFieldEntryType.APPLICATION,
    entryValues: [],
    isActive: true,
    otherAttributes: {},
    referenceObject: {
      type: ConfigEntryFieldType.TEXTAREA,
      label: 'Provide your comments',
      placeHolder: 'Provide your comments...',
      isRequired: true,
    },
  },
];

export const ARTICLE_FORM_TOP_LEVEL_FIELDS = {
  [ArticleSourceType.POST]: ['title', 'description', 'attachments'],
  [ArticleSourceType.QUESTION]: ['description', 'attachments'],
  [ArticleSourceType.SUGGESTION]: [],
};

export const ARTICLE_DETAILS_TOP_LEVEL_FIELDS = {
  [ArticleSourceType.POST]: ['title', 'attachments', 'description'],
  [ArticleSourceType.QUESTION]: ['title', 'attachments', 'description'],
  [ArticleSourceType.SUGGESTION]: ['title', 'attachments', 'description'],
};

export const FULL_WIDTH_ARTICLE_FIELDS = [
  'title',
  'description',
  'attachments',
  'divisions',
  'specSections',
  'comment',
];
